import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export type TrackAssetModalInfoPanelSectionToggled = {
  section: 'boards' | 'descriptionAndTags' | 'exif' | 'customFields';
  isExpanded: boolean;
};

export const useTrackAssetModalInfoPanelSectionToggled = () => {
  const { track } = useAnalyticsUtilities();

  const trackAssetModalInfoPanelSectionToggled = useCallback(
    ({ section, isExpanded }: TrackAssetModalInfoPanelSectionToggled) => {
      track(`Toggled asset modal info panel section`, { section, isExpanded });
    },
    [track],
  );

  return { trackAssetModalInfoPanelSectionToggled };
};
